import { render, staticRenderFns } from "./CUpload.vue?vue&type=template&id=52f03b2f&scoped=true"
import script from "./CUpload.vue?vue&type=script&lang=js"
export * from "./CUpload.vue?vue&type=script&lang=js"
import style0 from "./CUpload.vue?vue&type=style&index=0&id=52f03b2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f03b2f",
  null
  
)

export default component.exports